module.exports = __webpack_public_path__ + "img/inline-mobile-arabic.d508d8cb.png";